import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { ImageIcon } from '../../theme/Icons';
import { AttachmentList } from '../generic-notes/attachments/AttachmentList';
import { createUseStyles } from 'react-jss';
import { isPlatform } from '../../utils/isPlatform';
import { LinkText } from '../../components/LinkText';

const useStyles = createUseStyles({
    attachmentArea: isPlatform('desktop') ? {
        '& hr': {
            width: '100%',
            marginBlockStart: -6
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    } : {
        minHeight: 70,
        '& hr': {
            marginBlockStart: -6
        }
    }
});

export const Attachments: FC<{ note: any; editHandler?: () => void; }> = ({ note, editHandler }) => {
    const classes = useStyles();

    if (!note.attachments.length && !editHandler) {
        return null;
    }

    return (
        <ViewNoteSection title="Attachments" Icon={ImageIcon}>
            {note.attachments.length > 0 ? (
                <div className={classes.attachmentArea}>
                    <AttachmentList
                        note={note}
                        attachments={note.attachments}
                        marginBottom={12}
                    />
                </div>
            ) : (
                <div>
                    {editHandler &&
                        <><LinkText data-type="edit-link" onClick={editHandler}>Edit</LinkText> to add relevant files, photos and more.</>
                    }
                </div>
            )}
        </ViewNoteSection>
    );
};
